const DEFAULT_CALLBACK_URL = '/'

export function getSafeCallbackUrl(
  callbackUrl: string | undefined,
  fallback: string = DEFAULT_CALLBACK_URL
): string {
  const raw = (callbackUrl ?? '').trim()
  if (!raw) return fallback

  // Relative path: must start with exactly one "/" (not "//")
  if (raw.startsWith('/') && !raw.startsWith('//')) {
    if (!raw.includes('\\')) return raw
  }

  // Absolute URL: must be same origin
  try {
    const parsed = new URL(raw)
    const baseUrl = process.env.NEXTAUTH_URL ?? process.env.NEXT_PUBLIC_URL ?? ''
    if (baseUrl && parsed.origin === new URL(baseUrl).origin) {
      return raw
    }
  } catch {
    /* invalid URL */
  }

  return fallback
}
